import React, { useState, useEffect } from "react";

//MUI
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";

import { DataGrid } from "@mui/x-data-grid";

//Icons
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import DeleteMapDialog from "../../components/dialogs/deleteGeneric";
import CreateMapDialog from "../../components/dialogs/createMap";
import UserPopover from "../../components/popovers/generic";

import mainURL from "../../config/environment";
import $ from "jquery";
import UpdateMapDialog from "../../components/dialogs/updateMap";

const emptyData = {
  id: "",
  mapURL: "",
  mapTitle: "",
};

const usePermissions = (refresh) => {
  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("userInfo")).token;
    const roleId = JSON.parse(localStorage.getItem("userInfo")).roleId;
    $.ajax({
      method: "GET",
      url: mainURL + `permissions/${roleId}`,
      contentType: "application/json",
      headers: {
        Authorization: "Bearer " + token,
      },
    }).done((res) => {
      //console.log(res);
      const aux = [];
      res.forEach((element) => {
        if (element.isAssigned) aux.push(element.permission);
      });
      setPermissions(aux);
    });
  }, []);
  return permissions;
};

const deleteMessage = "Something went wrong";
export default function MapManagement(props) {
  const { isAmericas } = props;

  //Permission management
  const permissions = usePermissions();
  const addPermission = permissions.find((x) => x === 14);
  const updatePermission = permissions.find((x) => x === 14);

  const screenSize = window.innerWidth;

  //Data management
  const [selectedData, setSelectedData] = useState(emptyData);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);

  let columns: GridColDef[] = [
    {
      headerName: "Title",
      field: "mapTitle",
      flex: 1,
    },
    {
      headerName: "Client",
      field: "clientName",
      //flex: 1,
    },
    {
      headerName: "Map",
      headerAlign: "center",
      field: "mapURL",
      //flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Grid container justifyContent="center">
          {params.row.mapURL !== "" ? (
            <a href={params.row.mapURL} target="_blank" rel="noreferrer">
              <Typography key={params.row.id} variant="body2" align="center">
                {"Visit"}
              </Typography>
            </a>
          ) : null}
        </Grid>
      ),
    },
    {
      headerName: "Options",
      field: "id",
      renderCell: (params: GridRenderCellParams) => (
        <IconButton onClick={handlePopoverOpen(params.row)}>
          <MoreVertIcon />
        </IconButton>
      ),
      //flex: 1,
      align: "center",
      headerAlign: "center",
      sortable: false,
      editable: false,
    },
  ];

  if (!updatePermission) {
    columns = columns.filter((x) => x.headerName !== "Options");
  }

  if (screenSize < 600) {
    columns = columns.filter(
      (x) => x.headerName === "Options" || x.headerName === "Title"
    );
  }

  //Dialog management
  const [createDialog, setCreateDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const handleCloseDialogs = () => {
    setCreateDialog(false);
    setDeleteDialog(false);
    setUpdateDialog(false);
  };

  //Notification management
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState({
    severity: "",
    message: "",
  });

  const handleShowNotification = (severity, message) => {
    setNotificationMessage({ severity: severity, message: message });
    setShowNotification(true);
    setTimeout(function () {
      setShowNotification(false);
    }, 5000);
  };

  //Popover management
  const [anchor, setAnchor] = useState(null);
  const handlePopoverOpen = (selected) => (event) => {
    event.stopPropagation();
    setAnchor(event.currentTarget);
    setSelectedData(selected);
  };

  const handlePopoverClose = () => {
    setAnchor(null);
  };

  const handleSelect = (data) => {
    if (data.row !== selectedData) setSelectedData(data.row);
    else setSelectedData(emptyData);
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("userInfo")).token;
    let isSubscribed = true;
    //handleShowNotification("info", "Loading users");
    $.ajax({
      method: "GET",
      url: mainURL + "map/get-all",
      contentType: "application/json",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .done((res) => {
        //console.log(res);
        const aux: GridRowsProp = res;
        if (isSubscribed) {
          setData(aux);
          setSelectedData(emptyData);
          //handleShowNotification("success", "Users loaded successfully");
        }
      })
      .fail((res) => {
        handleShowNotification("error", res.responseText);
      });
    return () => (isSubscribed = false);
  }, [refresh]);

  return (
    <Grid container direction="column" sx={{ p: 3 }}>
      <UserPopover
        open={anchor}
        showUpdateUser
        handleClose={handlePopoverClose}
        setUpdateDialog={setUpdateDialog}
        setDeleteDialog={setDeleteDialog}
      />
      <DeleteMapDialog
        refresh={refresh}
        open={deleteDialog}
        setRefresh={setRefresh}
        title={"Delete map"}
        name={selectedData.mapTitle}
        errorMessage={deleteMessage}
        handleClose={handleCloseDialogs}
        deleteURL={`map/${selectedData.id}`}
        handleShowNotification={handleShowNotification}
      />
      <CreateMapDialog
        refresh={refresh}
        open={createDialog}
        setRefresh={setRefresh}
        isAmericas={isAmericas}
        handleClose={handleCloseDialogs}
        handleShowNotification={handleShowNotification}
      />
      <UpdateMapDialog
        refresh={refresh}
        open={updateDialog}
        setRefresh={setRefresh}
        mapId={selectedData.id}
        handleClose={handleCloseDialogs}
        handleShowNotification={handleShowNotification}
      />
      <Grid
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ p: "2rem 0" }}
        spacing={2}
        container
      >
        <Grid item xs={8} md={8}>
          <Typography variant="h4">{"Map management"}</Typography>
        </Grid>

        {showNotification ? (
          <Grid item xs={12} md={4}>
            <Alert variant="outlined" severity={notificationMessage.severity}>
              {notificationMessage.message}
            </Alert>
          </Grid>
        ) : addPermission ? (
          <Grid item xs={4} md={4} container justifyContent="flex-end">
            <Button variant="contained" onClick={() => setCreateDialog(true)}>
              <PlaylistAddIcon sx={{ mr: 1 }} />
              {"Add"}
            </Button>
          </Grid>
        ) : null}
      </Grid>

      <Grid container height={"60vh"}>
        <DataGrid
          selectionModel={selectedData.id === 0 ? [] : selectedData.id}
          onRowClick={handleSelect}
          columns={columns}
          disableColumnMenu
          autoPageSize
          rows={data}
        />
      </Grid>
    </Grid>
  );
}
